import React from 'react'
import { MembershipTaskListContextProvider } from '../../features/MembershipTaskList/MembershipTaskListContextProvider';
import EditMembershipTaskListForm from '../../features/MembershipTaskList/EditMembershipTaskListForm';

const EditMembershipTaskList = () => {
  return (
    <MembershipTaskListContextProvider>
      <EditMembershipTaskListForm />
    </MembershipTaskListContextProvider>
  )
}

export default EditMembershipTaskList;